// featured-links__list-wrapper
export default () => {
	const ul = document.querySelector('.featured-links__list-wrapper ul');
	const list = document.querySelectorAll('.featured-links__list-wrapper li');
	const figure = document.querySelector('.featured-links__figure');
	const images = document.querySelectorAll('.featured-links__figure img');

	const moveFigure = (e) => {
		const target = e.currentTarget;
		const rect = target.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;
		figure.style.left = x + 'px';
		figure.style.top = y + 'px';
	};

	list.forEach((el) => {
		el.onmouseenter = (e) => {
			const index = e.currentTarget.dataset.index;
			images.forEach((img) => {
				if (img.dataset.index && img.dataset.index === index) {
					img.classList.add('show');
				}
			});
			figure.classList.add('is-hover');
			ul.addEventListener('mousemove', moveFigure);
		};

		el.onmouseleave = () => {
			figure.classList.remove('is-hover');
			ul.removeEventListener('mousemove', moveFigure);
			images.forEach((img) => img.classList.remove('show'));
		};
	});
};
